<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <mrc_ess_iconGroup
      :is_disabled="iconstatus"
      :showEdit="hasBtn('edit-client')"
      :show_del="hasBtn('delete-client')"
      :showReturn="false"
      @handleEdit="change"
      @handleDel="del"
    ></mrc_ess_iconGroup>

    <v-tabs
      v-model="tab2"
      color="primary"
      grow
      background-color="#eeeef0"
      @change="tabs2change"
    >
      <v-tab v-for="(item, index) in items2" class="text-capitalize" :key="index">
        {{ item.tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab2">
      <!-- 管理员账号 -->
      <v-tab-item style="background-color: #eeeef0">
        <clientuser
          :list="manager_accounts"
          @change="iconchange"
          :readonly="iconstatus"
        ></clientuser>
      </v-tab-item>
      <!-- 客户资料 -->
      <v-tab-item style="background-color: #eeeef0">
        <adduser :list="masterlist" :readonly="iconstatus" ref="tabadduser">
          <template v-slot:submitBtn>
            <mrc_ess_submitBtn
              @cancel="edmitbtn('user')"
              v-if="!iconstatus"
              :loading="btnloading"
              @success="sumbit('user')"
            ></mrc_ess_submitBtn>
          </template>
        </adduser>
        <!-- <mrc_ess_submitBtn @cancel="edmitbtn"
                           v-if="!iconstatus"
                           :loading="btnloading"
                           @success="sumbit('user')">
        </mrc_ess_submitBtn> -->
      </v-tab-item>
      <!-- 权限验证 -->
      <v-tab-item style="background-color: #eeeef0">
        <quanxianpeizhi
          :uuidslist="mrbase_sys_function_permission"
          :disabled="iconstatus"
          ref="tabquanxian"
        >
          <template v-slot:submitBtn>
            <mrc_ess_submitBtn
              @cancel="edmitbtn('quanxian')"
              v-if="!iconstatus"
              :loading="btnloading"
              @success="sumbit('quanxian')"
            ></mrc_ess_submitBtn>
          </template>
        </quanxianpeizhi>
      </v-tab-item>
      <!-- 白名单 -->
      <v-tab-item style="background-color: #eeeef0">
        <baimingdan
          :list="mrbase_sys_client_email_whitelist"
          :readonly="iconstatus"
          ref="tabbaimingdan"
          @emailbtnchange="emailbtnchange"
        >
          <template v-slot:submitBtn>
            <mrc_ess_submitBtn
              @cancel="edmitbtn('email')"
              v-if="!iconstatus"
              :loading="btnloading"
              :disabled="btndisabled"
              @success="sumbit('email')"
            ></mrc_ess_submitBtn>
          </template>
        </baimingdan>
      </v-tab-item>
      <!-- 语言 -->
      <v-tab-item style="background-color: #eeeef0">
        <yuyan :list="mrbase_sys_client_language" :readonly="true" ref="tabyuyan"></yuyan>
        <!-- <mrc_ess_submitBtn @cancel='edmitbtn'
                               :loading='btnloading'
                               @success="sumbit('language')"></mrc_ess_submitBtn> -->
      </v-tab-item>
    </v-tabs-items>
    <!-- 
      <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
        this.skeletonloading = true
      await this.national('mrbase_sys_flow_proxy_approval') 
      -->
  </mrc_ess_skeleton_loader>
</template>

<script>
import axios from "axios";
import { SASTOKEN } from "@/utils/constant.js";
import adduser from "./modules/adduser";
import clientuser from "./clientuser.vue";
import baimingdan from "./baimingdan.vue";
import quanxianpeizhi from "./quanxianpeizhi.vue";
import yuyan from "./yuyan.vue";
import {
  getclientdetail,
  updateclientdetail,
  updatequanxian,
  updatewhite,
  updatelanguage,
  edmitclientdetail,
} from "@/service/api/clientmanage_api.js";
export default {
  components: {
    clientuser,
    baimingdan,
    quanxianpeizhi,
    yuyan,
    adduser,
  },
  watch: {
    iconstatus: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_customers";
          this.$store.commit("set_page_title", "label_edit_customers");
        } else {
          this.$route.meta.title = "label_view_customers";
          this.$store.commit("set_page_title", "label_view_customers");
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      btndisabled: false,
      btnloading: false, //按钮加载状态
      loading: false,
      skeletonloading: true,
      iconstatus: false, // 图标的显示隐藏
      tab: 0,
      tab2: 0,
      uuid: "",
      masterlist: {}, //客户主表信息
      mrbase_sys_client_email_whitelist: [], //客户白名单邮箱
      mrbase_sys_client_language: [], //语言列表
      function_permission: [], // 功能权限列表
      manager_accounts: [], //需要改名
      mrbase_sys_function_permission: [], //默认选中uuids  默认权限
      oldtreelist: [], //保存老的用户默认选择listtree数据
    };
  },
  async mounted() {
    this.iconstatus = this.$store.state.iconstatus;
    this.tab = this.$store.state.tab | 0;
    this.tab2 = this.$store.state.tab2 | 0;
    this.$store.commit("setTab", this.tab);
    this.$store.commit("setTab2", this.tab2);
    const uuid = this.$route.params.uuid || this.$store.state.detailuuid;
    if (uuid) {
      await this.getlist();
    } else {
      // 新增用户逻辑处理
    }
  },
  beforeDestroy() {
    this.$store.commit("setTab", "");
    this.$store.commit("setTab2", "");
    this.$store.commit("set_iconstatus", ""); // 图标状态
    this.$store.commit("set_uuid", "");
    this.$store.commit("set_detailuuid", "");
    this.$store.commit("set_subPage_name", "");
  },
  updated() {},
  computed: {
    items2() {
      return [
        { tab: this.$t("label_Administrator_account") },
        { tab: this.$t("label_Customer_data") },
        { tab: this.$t("label_Function_permission_configuration") },
        { tab: this.$t("label_Email_Whitelist") },
        { tab: this.$t("label_language") },
      ];
    },
    items() {
      return [
        { tab: this.$t("label_Administrator_account") },
        { tab: this.$t("label_Customer_data") },
        { tab: this.$t("label_Function_permission_configuration") },
        { tab: this.$t("label_Email_Whitelist") },
        { tab: this.$t("label_language") },
      ];
    },
  },
  methods: {
    iconchange() {
      this.change();
    },
    tabchange() {
      this.$store.commit("setTab", this.tab);
    },
    tabs2change() {
      this.$store.commit("setTab2", this.tab2);
    },
    emailbtnchange(v) {
      this.btndisabled = v;
    },
    async getlist() {
      this.skeletonloading = true;
      const uuid = this.$route.params.uuid || this.$store.state.detailuuid;
      const res = await getclientdetail({ uuid });
      this.skeletonloading = false;
      this.masterlist = res.data;
      this.manager_accounts = res.data.manager_accounts; //管理员账号
      this.mrbase_sys_client_email_whitelist = res.data.mrbase_sys_client_email_whitelist; //白名单
      this.mrbase_sys_client_language = res.data.mrbase_sys_client_language; //语言列表
      this.function_permission = res.data.function_permission_tree; //功能权限列表
      this.mrbase_sys_function_permission = res.data.mrbase_sys_function_permission
        ? res.data.mrbase_sys_function_permission
        : []; //默认选中权限
      this.oldtreelist = res.data.mrbase_sys_function_permission
        ? res.data.mrbase_sys_function_permission
        : [];
    },
    goback() {},
    del() {
      //删除
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then(() => {
        const uuid = this.$store.state.detailuuid;
        edmitclientdetail({ uuid }).then((res) => {
          this.$router.push({
            name: "clientmanage",
            params: {
              type: "del",
            },
          });
        });
      });
    },
    change() {
      // 修改按钮被点击
      this.$store.commit("setTab2", this.tab2);
      this.iconstatus = !this.iconstatus;
      this.$store.commit("set_iconstatus", this.iconstatus); // 图标状态
    },
    changeicons(item) {},
    edmitbtn() {
      this.getlist();
      this.change();
      // if (name === 'user') {

      // }
      // if (name === 'email') {

      // }
      // if (name === 'quanxian') {

      // }
      //取消
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'clientmanage',
      //     })
      //   })
      //   .catch((err) => { })
    },
    async sumbit(name) {
      //提交内容
      if (name === "user") {
        if (this.$refs.tabadduser.formverify()) {
          var userdetail = JSON.parse(JSON.stringify(this.$refs.tabadduser.userdetail));
          delete userdetail.mrbase_sys_function_permission; //删除权限该
          delete userdetail.mrbase_sys_client_contacts;
          delete userdetail.mrbase_sys_client_email_whitelist;
          delete userdetail.mrbase_sys_client_language;
          delete userdetail.function_permission;
          delete userdetail.mrbase_sys_org_levels;
          delete userdetail.manager_accounts;
          delete userdetail.function_permission_tree;
          this.$refs.tabadduser.desserts
            ? this.$refs.tabadduser.desserts
            : (this.$refs.tabadduser.desserts = []);
          let userres = {
            ...userdetail,
            mrbase_sys_client_contacts: [
              ...this.$refs.tabadduser.desserts,
              ...this.$refs.tabadduser.deletedessertslist,
            ],
          };
          this.btnloading = true;
          // 删除文件
          let deleteFileArr = [];
          this.$refs.tabadduser.deleteFileList.forEach((item) => {
            deleteFileArr.push(item.uuid);
          });
          let deleteFileUuid = deleteFileArr.join();
          //上传文件
          let p1 = this.$uploadFiles(this.$refs.tabadduser.light_mode_icon_file, {
            module_uuid: "client",
            function_uuid: this.$store.state.menuFunctionUuid,
            attachment_data_table: "mrbase_sys_clients",
            attachment_data_field: "light_mode_icon",
            org_level_uuid: this.$store.state.currentCompany,
            uuid: this.$store.state.detailuuid,
          });

          let p2 = this.$uploadFiles(this.$refs.tabadduser.dark_mode_icon_file, {
            module_uuid: "client",
            function_uuid: this.$store.state.menuFunctionUuid,
            attachment_data_table: "mrbase_sys_clients",
            attachment_data_field: "dark_mode_icon",
            org_level_uuid: this.$store.state.currentCompany,
            uuid: this.$store.state.detailuuid,
          });
          let urlList = [];
          let sasToken = "";
          // console.log(1);
          await Promise.all([p1, p2]).then(async (res) => {
            if (
              typeof (res[0] == "object") &&
              res[0] != undefined &&
              res[0].code == 200
            ) {
              userres.light_mode_icon = res[0].uuid;
              urlList.push(res[0].uuid);
              sasToken = res[0].sasToken;
            } else {
            }
            if (
              typeof (res[1] == "object") &&
              res[1] != undefined &&
              res[1].code == 200
            ) {
              userres.dark_mode_icon = res[1].uuid;
              urlList.push(res[1].uuid);
              sasToken = res[1].sasToken;
            } else {
            }
            await updateclientdetail({ ...userres, del: deleteFileUuid })
              .then((resp) => {
                if (resp.code == 200) {
                  this.$refs.tabadduser.deleteFileList.forEach((item) => {
                    //删除用户删除的删除文件
                    this.$deleteFile(item.uuid);
                  });
                  this.$Message({
                    text: this.$t("message_The_operation_was_successful"),
                  });
                  this.getlist();
                  this.$refs.tabadduser.deleteFileList = [];
                  this.change();
                } else {
                  urlList.forEach((item) => {
                    //修改失败删除已经上传的文件
                    this.$deleteFile(item);
                  });
                }
              })
              .catch((err) => {
                this.btnloading = false;
              });
          });
          // console.log(4);
          this.btnloading = false;
        } else {
          this.$myConfirm({
            content: this.$t("message_The_information_was_not_entered_completely"),
          });
        }
      }
      if (name === "email") {
        if (this.$refs.tabbaimingdan.isemail != "") return;
        this.btnloading = true;
        setTimeout(async () => {
          if (this.$refs.tabbaimingdan) {
            const datastorage = this.$refs.tabbaimingdan.datastorage || []; //保存的数据
            const states = this.$refs.tabbaimingdan.states || []; //用户修改的数据
            // console.log(this.$refs.tabbaimingdan.states);
            // console.log(datastorage, states);
            var result = [];
            if (datastorage) {
              for (var i = 0; i < datastorage.length; i++) {
                var uuid = datastorage[i].uuid;
                var isExist = false;
                for (let j = 0; j < states.length; j++) {
                  if (states[j].uuid == uuid) {
                    isExist = true;
                    break;
                  }
                }
                if (!isExist) {
                  result.push({ ...datastorage[i], "~type~": "del" });
                }
              }
            }
            // console.log(result);
            // const arr1 = []
            states.map((item) => {
              if (typeof item == "string") {
                const obj = {};
                obj["~table~"] = "mrbase_sys_client_email_whitelist";
                obj["whitelist_domain"] = item;
                // obj['client_whitelist_id'] = 50
                result.push(obj);
              } else {
                result.push(item);
              }
            });

            await updatewhite({
              //发送请求
              uuid: JSON.parse(this.$ls.get("detailuuid")),
              client_name: this.$store.state.subPage_name,
              mrbase_sys_client_email_whitelist: result,
            }).then(async (res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_operation_was_successful"),
                });
                this.getlist();
                this.change();
              }
            });
            this.btnloading = false;
          }
        }, 1);
      }
      if (name === "language") {
        if (this.$refs.tabyuyan) {
          const languagelist = this.$refs.tabyuyan.mrbase_sys_client_language;
          if (languagelist) {
            this.btnloading = true;
            await updatelanguage({
              uuid:
                this.$store.state.detailuuid || JSON.parse(this.$ls.get("detailuuid")),
              client_name: this.$store.state.subPage_name,
              mrbase_sys_client_language: languagelist,
            }).then(async (res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_operation_was_successful"),
                });
                this.getlist();
                this.change();
              }
            });
            this.btnloading = false;
          } else {
            this.$myConfirm({
              content: this.$t("message_default_language_must_be_selected"),
            });
          }
        }
      }
      if (name === "quanxian") {
        if (this.$refs.tabquanxian) {
          const uuid =
            this.$store.state.detailuuid || JSON.parse(this.$ls.get("detailuuid"));
          const role_uuid = this.$store.state.uuid || JSON.parse(this.$ls.get("uuid"));
          const obj = this.$refs.tabquanxian.success();
          // console.log(obj);
          if (obj.NoButton) {
            this.$Message({
              text: this.$t(
                "message_Permission list features_and_buttons_cannot_be_empty"
              ),
              color: "rgba(0,0,0,0.78)",
            });
            return;
          }
          let mrbase_sys_function_permission = obj.button_uuid_arr.map((item) => {
            return {
              function_uuid: item.uuid1,
              button_uuid: item.uuid,
              role_uuid: role_uuid,
            };
          });
          let delete_function_buttons = obj.delete_uuid_arr.map((item) => {
            return {
              function_uuid: item.uuid1,
              button_uuid: item.uuid,
              role_uuid: role_uuid,
            };
          });
          this.btnloading = true;
          await updatequanxian({
            //发送请求
            uuid: uuid,
            role_uuid,
            client_name: this.$store.state.subPage_name,
            mrbase_sys_function_permission,
            delete_function_buttons,
          }).then(async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              this.change();
              this.getlist();
            }
          });
          this.btnloading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.border1 {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.icon-box {
  position: fixed;
  top: 75px;
  right: 73px;
}

.btn-icon {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: primary;
}

.icon {
  padding: 15px 10px;
  color: white;
}

.btn {
  color: rgb(255, 173, 77);
  margin: 27px 60px;
  border-radius: 20%;
}

.btn:hover {
  background-color: rgb(255, 173, 77);
  color: white;
}

.btnbgd {
  background-color: #ccc;
  /* margin: 0 30px; */
  height: 80px;
}

.v-stepper__content {
  padding: 0px 0px;
}
</style>
